import { revenueCatalogue } from './revenueCatalogue.js';

const domainOf = (url) => {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return ''; }
};

/**
 * The Revenue tab: the money third parties make from housing providers, by BedMaps module (repairs, safety checks, utilities,
 * insurance…). With no `module` it lists the modules and who gets paid in each. A module's page has a Who gets paid dropdown
 * (`payee`, such as plumbers or insurers) and lists what they sell, the typical UK price, how often it is paid and where the price
 * came from. The Module dropdown moves between the pages. `onOpen(params)` changes what is shown.
 */
export default function RevenueTab({ module, payee, onOpen }) {
  const open = revenueCatalogue.find((item) => item.key === module);
  const who = open && (open.payees.find((item) => item.key === payee) || open.payees[0]);
  const choose = (key) => onOpen(key ? { module: key } : {});
  return (
    <>
      <div className="mod-filters">
        <label>Module
          <select value={open?.key || ''} onChange={(event) => choose(event.target.value)}>
            <option value="">All modules</option>
            {revenueCatalogue.map((item) => <option key={item.key} value={item.key}>{item.name}</option>)}
          </select>
        </label>
        {open && open.payees.length > 1 && (
          <label>Who gets paid
            <select value={who.key} onChange={(event) => onOpen({ module: open.key, payee: event.target.value })}>
              {open.payees.map((item) => <option key={item.key} value={item.key}>{item.name}</option>)}
            </select>
          </label>
        )}
      </div>
      {open ? (
        <div className="mod-table-wrap">
          <table className="mod-audit data-catalogue data-records" aria-label={`What housing providers pay for: ${open.name}, ${who.name}`}>
            <thead><tr><th scope="col">What they sell</th><th scope="col">Typical price</th><th scope="col">How often</th><th scope="col">Source</th></tr></thead>
            <tbody>
              {who.items.map((item) => (
                <tr key={item.what}>
                  <td className="data-point">{item.what}</td>
                  <td className="data-example">{item.price ? `${item.price}${item.basis ? ` ${item.basis}` : ''}` : 'Not found yet'}</td>
                  <td className="data-example">{item.often || '–'}</td>
                  <td className="data-example">
                    {item.source ? <a className="admin-ext" href={item.source} target="_blank" rel="noreferrer">{domainOf(item.source) || 'Source'}</a> : '–'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="mod-table-wrap">
          <table className="mod-audit data-catalogue" aria-label="What housing providers pay third parties for, by module">
            <thead><tr><th scope="col">Module</th><th scope="col">Who gets paid</th></tr></thead>
            <tbody>
              {revenueCatalogue.map((item) => (
                <tr key={item.key}>
                  <th scope="row"><button type="button" className="admin-link" onClick={() => choose(item.key)}>{item.name}</button></th>
                  <td>{item.payees.map((entry) => entry.name).join(', ')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p className="mod-note">Typical UK prices from public price guides and sector reports, each linked to where it came from. Not BedMaps data.</p>
    </>
  );
}
